import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useRef, useState } from "react";
import ItemsSelectFieldStandalone from "../forms/stand-alone-select-field";
import { useFormikContext } from "formik";
import AddButton from "../buttons/button";
import CloseIcon from "../../assets/icons/close-icon";
import { useDispatch } from "react-redux";
import LoadingOverlay from "../helper-components/overlay-loading";
import { invoiceAlternativeAction } from "../../redux/actions/invoices-action";
import { truncateString } from "../helper-components/helper-function";
import {
  producBatchDetailsAction,
  producDetailsAction,
  productListAction,
} from "../../redux/actions/general-action";
import ItemsSearchSelectFieldStandalone from "../forms/stand-alone-search-select-field";
import { useHotkeys } from "../helper-components/use-hotkeys";

export default function BillingAlternativeItemPanel({
  open,
  setOpen,
  selectedItem,
  qtyRef,
  is_auto_batch,
  setBatchModalOpen,
}) {
  const addButtonRef = useRef(null);

  useHotkeys("1", () => {
    if (addButtonRef.current) {
      addButtonRef.current.click();
    }
  });

  const [currentPage] = useState(1);
  const [pageSize] = useState(20);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { values, setFieldValue } = useFormikContext();
  const [productDetails, setProductDetails] = useState({
    item_id: selectedItem?.itemid,
    items: [],
  });

  useEffect(() => {
    setProductDetails((prev) => ({
      ...prev,
      item_id: selectedItem?.itemid ?? "",
    }));
  }, [selectedItem]);

  const productList = Array.isArray(values?.data)
    ? values.data.map((item) => ({
      label: item?.item_name ?? "",
      value: item?.item_id ?? "",
    }))
    : [];

  useEffect(() => {
    if (productDetails.item_id && open) {
      setLoading(true);
      dispatch(
        invoiceAlternativeAction(
          {
            pageNumber: currentPage,
            pageSize: pageSize,
            alternative_id: productDetails.item_id,
          },
          onSuccess,
          onError
        )
      );
    }
  }, [productDetails.item_id, open]);

  const onSuccess = (data) => {
    setLoading(false);
    setProductDetails((prev) => ({
      ...prev,
      items: data?.data?.alternativeProducts || [],
    }));
  };
  const onError = (data) => {
    setLoading(false);
    setProductDetails((prev) => ({
      ...prev,
      items: [],
    }));
  };

  const onSuccessDetails = (data, filteredData) => {
    setLoading(false);
    const updatedTempRowData = {
      item_code: filteredData.item_code,
      item_name: filteredData.item_name,
      total_sellable_quantity: data?.data?.total_sellable_quantity ?? 0,
      quantity: "",
      item_free_quantity: 0,
      item_uom: data?.data?.item_uom,
      item_batch_number: "",
      item_exp_date: "",
      item_rack_location: filteredData?.item_rack_location || "",
      item_manufacturer_name: filteredData.item_manufacturer_name,
      item_schedule: filteredData?.item_schedule || "",
      item_hsn: filteredData?.item_hsn ?? "",
      item_unit_price: 0.0,
      item_price_wiithout_tax: 0.0,
      item_discount_amount: 0.0,
      item_discount_percentage: "",
      item_tax_amount: 0.0,
      item_gst: 0,
      item_final_price: 0.0,
      item_margin_percentage: 0.0,
      item_total_amount: 0.0,
      item_id: filteredData?.item_id,
      item_total_tax_percentage: 0,
      instock: true,
      item_manufacturer_id: filteredData.item_manufacturer,
      item_uom_id: data?.data?.item_uom_id || filteredData.item_uom_id,
      item_generic_name: filteredData?.item_generic_name,
      uom_dropdown: data?.data?.uom_dropdown ?? [],
    };
    setFieldValue("tempRowData", updatedTempRowData);
    setTimeout(() => {
      qtyRef.current.focus();
    }, 500);
    setOpen(false);
  };

  const onErrorDetails = (data) => {
    setLoading(false);
  };

  const onSuccessBatchDetails = (data, rowData) => {
    console.log(data, "dfdsfsfsdfsdfsdf");
    const updatedTempRowData = {
      ...rowData,
      item_code: rowData.item_code,
      item_name: rowData.item_name,
      total_sellable_quantity: 0,
      quantity: "",
      item_free_quantity: 0,
      item_uom: "",
      item_batch_number: "",
      item_exp_date: "",
      item_rack_location: rowData?.item_rack_location || "",
      item_manufacturer_name: rowData.item_manufacturer_name || "",
      item_schedule: rowData?.item_schedule || "",
      item_hsn: rowData?.item_hsn ?? "",
      item_unit_price: 0.0,
      item_price_wiithout_tax: 0.0,
      item_discount_amount: 0.0,
      item_discount_percentage: "",
      item_tax_amount: 0.0,
      item_gst: 0,
      item_final_price: 0.0,
      item_margin_percentage: 0.0,
      item_total_amount: 0.0,
      item_id: rowData?.item_id,
      item_total_tax_percentage: 0,
      instock: true,
      item_manufacturer_id: rowData.item_manufacturer,
      item_uom_id: rowData.item_uom,
      item_generic_name: rowData?.item_generic_name,
      item_Batch_List: data?.data || [],
    };
    setFieldValue("tempRowData", updatedTempRowData);
    setOpen(false);
    setBatchModalOpen(true);
  };

  console.log(productDetails, "sdfsgsdfdsfdsfsfsdf");

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        onClose={() => {
          setOpen(false);
          setProductDetails({ item_id: "" });
        }}
      >
        <div className="fixed inset-0 overflow-hidden">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="absolute inset-0 bg-[#0000004D]" />
          </Transition.Child>

          <div className="fixed inset-0 flex justify-end">
            <Transition.Child
              as={Fragment}
              enter="transform transition ease-in-out duration-300"
              enterFrom="translate-x-full"
              enterTo="translate-x-0"
              leave="transform transition ease-in-out duration-300"
              leaveFrom="translate-x-0"
              leaveTo="translate-x-full"
            >
              <Dialog.Panel className="h-full w-[400px] sm:w-[900px] bg-white overflow-y-auto rounded-tl-lg rounded-bl-lg shadow-xl">
                <div
                  className="h-[61px] bg-[var(--slide-panel-head-bg)] px-3 flex items-center justify-between border-b"
                  style={{ borderColor: "var(--slide-panel-border)" }}
                >
                  <div className="max-w-[75%] w-[75%] flex gap-5">
                    <div className="max-w-[60%] w-[60%]">
                      <ItemsSelectFieldStandalone
                        isSearchable={false}
                        labelClass={"max-w-[10rem] w-[10rem]"}
                        fieldClass={`max-w-[70%] w-[70%]`}
                        label="Alternatives"
                        isLabelReq
                        value={productDetails.item_id}
                        onChange={(sel) => {
                          setProductDetails((prev) => ({
                            ...prev,
                            item_id: sel?.value,
                            item_name: sel?.label,
                          }));
                        }}
                        options={productList}
                      />
                    </div>
                    <div className="max-w-[40%] w-[40%]">
                      <ItemsSearchSelectFieldStandalone
                        placeholder="Item Name"
                        fieldClass="min-w-[100%]"
                        value={
                          productDetails?.item_id
                            ? {
                              label: productDetails?.item_name,
                              value: productDetails?.item_id,
                            }
                            : null
                        }
                        handleChange={(selectedOption, actionMeta) => {
                          setProductDetails((prev) => ({
                            ...prev,
                            item_id: selectedOption?.value,
                            item_name: selectedOption?.label,
                          }));
                        }}
                        action={productListAction}
                        field={"item_name"}
                      />
                    </div>
                  </div>
                  <AddButton
                    onclkFn={() => {
                      setOpen(false);
                    }}
                    icon={
                      <CloseIcon
                        width="12px"
                        height="12px"
                        fill="var(--close-button-fg)"
                      />
                    }
                    text={
                      <span>
                        Close <span className="opacity-50">(X)</span>{" "}
                      </span>
                    }
                    className="flex h-[32px]  items-center gap-2 bg-[var(--close-button-bg)] border-radius px-3 text-[var(--close-button-fg)]"
                  />
                </div>
                <div
                  style={{
                    maxHeight: `calc(100% - 61px)`,
                    minHeight: `calc(100% - 61px)`,
                  }}
                  className="tab-container"
                >
                  <table className="w-full border-collapse mt-0">
                    <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
                      <tr className="relative h-[50px]">
                        {heading
                          ?.filter((heading) => heading?.enabled !== false)
                          ?.map((heading, index) => (
                            <th
                              style={{ minWidth: `${heading?.minWidth}px` }}
                              key={index}
                              className={`px-4 whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
                            >
                              <div
                                className="flex items-center gap-2 w-full"
                                style={{
                                  justifyContent:
                                    heading?.alignment === "right"
                                      ? "flex-end"
                                      : heading?.alignment === "center"
                                        ? "center"
                                        : "flex-start",
                                }}
                              >
                                {heading?.label}
                              </div>
                            </th>
                          ))}
                      </tr>
                    </thead>
                    <tbody className="h-full">
                      {productDetails?.items?.length > 0 ? (
                        <>
                          {" "}
                          {productDetails?.items?.map((rowData, rowIndex) => (
                            <tr
                              className={`hover:bg-[var(--create-table-row-hover-bg)] bg-[var(--create-table-row-bg)]  h-[50px] `}
                              key={rowIndex}
                            >
                              {heading
                                ?.filter(
                                  (heading) => heading?.enabled !== false
                                )
                                ?.map((heading, index) => {
                                  return (
                                    <td
                                      style={{
                                        minWidth: `${heading?.minWidth}px`,
                                        textAlign: heading?.alignment, // Keep textAlign for normal text cells
                                      }}
                                      key={index}
                                      className="border-b border-[var(--create-table-border)] px-4 text-left text-[length:var(--create-table-row-font-size)] font-[var(--create-table-row-font-weight)] text-[var(--create-table-row-fg-color)] whitespace-nowrap cursor-pointer"
                                    >
                                      {heading?.value === "action" ? (
                                        <AddButton
                                          ref={addButtonRef}
                                          onclkFn={() => {
                                            let actionType =
                                              producBatchDetailsAction;
                                            if (is_auto_batch) {
                                              actionType = producDetailsAction;
                                            }
                                            dispatch(
                                              actionType(
                                                {
                                                  item_id: rowData?.item_id,
                                                  item_uom: rowData?.item_uom,
                                                },
                                                (data) => {
                                                  if (is_auto_batch) {
                                                    onSuccessDetails(
                                                      data,
                                                      rowData
                                                    );
                                                  } else {
                                                    onSuccessBatchDetails(
                                                      data,
                                                      rowData
                                                    );
                                                  }
                                                },
                                                onErrorDetails
                                              )
                                            );
                                          }}
                                          prefixIcon={false}
                                          text={
                                            <span>
                                              Add{" "}
                                              <span className="opacity-50">
                                                ({rowIndex + 1})
                                              </span>{" "}
                                            </span>
                                          }
                                          className="
                 flex items-center px-[12px] h-[32px] whitespace-nowrap rounded-md gap-[8px]
                 bg-[var(--add-button-bg)] cursor-pointer
                 text-[var(--add-button-fg)]
                 text-[length:var(--add-button-fs)] 
                 font-[var(--add-button-fw)]
               "
                                          type="button"
                                        />
                                      ) : (
                                        truncateString(
                                          rowData[heading.value] || "--",
                                          70
                                        )
                                      )}
                                    </td>
                                  );
                                })}
                            </tr>
                          ))}
                        </>
                      ) : (
                        <tr>
                          <td
                            colSpan={
                              heading?.filter((h) => h?.enabled !== false)
                                .length
                            }
                            className="text-center py-4 text-[length:var(--tab-empty-comp-fs)] border-b border-[var(--create-table-border)] font-[var(--tab-empty-comp-fw)] text-[var(--tab-empty-comp-fg)]"
                          >
                            No alternative product equivalent found for this
                            reference product.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  <LoadingOverlay isLoading={loading} />
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

const heading = [
  {
    label: "Item Code",
    value: "item_code",
  },
  {
    label: "Item Name",
    value: "item_name",
  },
  {
    label: "Item Unit Price",
    value: "item_unit_price",
  },
  {
    label: "Quantity",
    value: "total_sellable_quantity",
  },
  {
    label: "Action",
    value: "action",
  },
];
